import { NarrowPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { Result } from "antd";
import { RootComponent } from "route-components/RootComponent";
import { createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
    component: RootComponent,
    notFoundComponent: () => (
        <NarrowPageContentContainer>
            <Result status="404" title="Not found" subTitle="We couldn't find the page you're looking for." />
        </NarrowPageContentContainer>
    ),
});
